import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import mapStateToProps from '../../../store/mapStateToProps';
import mapDispatchToProps from '../../../store/mapDispatchToProps';
import { hit } from '../../metrics';
import HelmetSite from '../HelmetSite';
import CaseFooterNew from '../CaseFooterNew';
import './style.css';

const base = '/cases/img/opus';
const textFrames = new Set(['03', '05', '06', '07', '08', '09', '11', '12']);
const frameImage = name => `${base}/${name}.${textFrames.has(name) ? 'webp' : 'png'}`;

const introCopy = [
  'Дизайн сайта развивает фирменный стиль, делая его живым и динамичным. Фоновые видео с водой, анимированные волны и тщательно подобранные изображения создают атмосферу лёгкости и курортного отдыха. Белый цвет и оттенки бирюзы подчёркивают чистоту и свежесть визуального языка.',
  'Пространство организовано так, чтобы обеспечить лёгкость восприятия и удобство навигации. Интуитивные элементы интерфейса и воздушная композиция делают взаимодействие с сайтом естественным и комфортным.'
];

const mobileCopy = [
  'Мобильная версия сайта полностью повторяет функционал основной версии, обеспечивая пользователям доступ ко всем необходимым функциям в любое время и в любом месте.',
  'Интерфейс оптимизирован для удобства использования на мобильных устройствах, что делает навигацию простой и интуитивной. При этом визуальный дизайн сохраняет эстетическую привлекательность, отражая фирменный стиль проекта и создавая гармоничное восприятие даже на небольших экранах.'
];

const sections = [
  { name: '03', ratio: '1921 / 1068.75', mobileRatio: '960.5 / 1068.75', mobile: 'split', video: true },
  { name: '04', ratio: '1921 / 1080', mobile: 'full' },
  { name: '05', ratio: '1920 / 1080', mobileRatio: '960 / 1080', mobile: 'split', video: true },
  { name: '06', ratio: '1921 / 1269.958', mobileRatio: '960.5 / 1269.958', mobile: 'split' },
  { name: '07', ratio: '1920 / 1080', mobile: 'full' },
  { name: '08', showcase: true },
  { name: '09', ratio: '1920 / 534.375', mobileRatio: '960 / 534.375', mobile: 'split' },
  { name: '10', ratio: '1921 / 1080', mobile: 'full' },
  { name: '11', liveMobile: true },
  { name: '12', ratio: '1921 / 1186', mobile: 'hidden', video: true }
];

const FrameMedia = ({ name, video, setVideoRef, className }) => video ? (
  <video ref={setVideoRef} className={className} muted loop playsInline preload="metadata" poster={frameImage(name)}>
    <source src={`${base}/${name}.mp4`} type="video/mp4" />
  </video>
) : <img className={className} src={frameImage(name)} alt="" loading="lazy" />;

const Frame = ({ name, ratio, mobileRatio = ratio, mobile, mobileAsset, video, setVideoRef }) => (
  <section className={`opus-frame opus-frame--${name}`} style={{ '--opus-ratio': ratio, '--opus-mobile-ratio': mobileRatio }}>
    {mobile === 'split' ? (
      <div className="opus-frame__desktop opus-frame__desktop-split">
        {['left', 'right'].map(side => (
          <div className={`opus-frame__desktop-panel opus-frame__desktop-panel--${side}`} key={side}>
            <FrameMedia name={name} video={video} setVideoRef={setVideoRef} className="opus-frame__desktop-media" />
          </div>
        ))}
      </div>
    ) : <FrameMedia name={name} video={video} setVideoRef={setVideoRef} className="opus-frame__desktop" />}
    {mobile !== 'hidden' && <div className={`opus-frame__mobile opus-frame__mobile--${mobile}`}>
      {mobile === 'split'
        ? <FrameMedia name={name} video={video} setVideoRef={setVideoRef} className="opus-frame__mobile-media" />
        : <img src={mobileAsset ? `${base}/${mobileAsset}.webp` : frameImage(name)} alt="" loading="lazy" />}
    </div>}
  </section>
);

const MobileSite = ({ setVideoRef }) => (
  <section className="opus-site opus-gap">
    <div className="opus-site__visual">
      <video ref={setVideoRef} className="opus-site__desktop" muted loop playsInline preload="metadata" poster={`${base}/11.webp`}>
        <source src={`${base}/11.mp4`} type="video/mp4" />
      </video>
      <img className="opus-site__mobile" src={`${base}/mobile-01.webp`} alt="Мобильная версия сайта Опус" loading="lazy" />
    </div>
    <div className="opus-site__copy">
      {mobileCopy.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
    </div>
  </section>
);

class VideoShowcase extends Component {
  state = { started: false };

  setVideo = node => { this.video = node; };

  play = event => {
    if (event) event.stopPropagation();
    if (!this.video) return;
    const playback = this.video.play();
    if (playback && playback.then) {
      playback.then(() => this.setState({ started: true })).catch(() => {});
    } else {
      this.setState({ started: true });
    }
  };

  playFromContainer = () => {
    if (!this.state.started && window.matchMedia('(max-width: 900px)').matches) this.play();
  };

  render() {
    return (
      <section className="opus-video-showcase opus-gap" onClick={this.playFromContainer}>
        <div className="opus-video-showcase__background" aria-hidden="true" />
        <div className="opus-video-showcase__player">
          {!this.state.started && <img className="opus-video-showcase__poster" src={`${base}/08-video.webp`} alt="Интерфейс сайта Опус" />}
          <video
            ref={this.setVideo}
            className={this.state.started ? 'is-started' : ''}
            playsInline
            preload="metadata"
            controls={this.state.started}
            onEnded={() => this.setState({ started: false })}
          >
            <source src={`${base}/showcase-video.mp4`} type="video/mp4" />
          </video>
          {!this.state.started && (
            <button className="opus-video-showcase__play" type="button" onClick={this.play} aria-label="Воспроизвести видео Опус">
              <img src="/cases/img/highlife/play.svg" alt="" />
            </button>
          )}
        </div>
      </section>
    );
  }
}

class Opus extends Component {
  videos = [];

  setVideoRef = node => {
    if (node && !this.videos.includes(node)) this.videos.push(node);
  };

  componentDidMount() {
    this.props.setProjectName('opus');
    $('body').addClass('case-expanded hash-opus');
    this.props.changeCase(null);
    window.scrollTo(0, 0);
    hit(window.location.pathname);

    if (this.videos.length && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.videoObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const play = entry.target.play();
            if (play && play.catch) play.catch(() => {});
          } else {
            entry.target.pause();
          }
        });
      }, { threshold: 0.08 });
      this.videos.forEach(video => this.videoObserver.observe(video));
    }
  }

  componentWillUnmount() {
    $('body').removeClass('hash-opus');
    if (this.videoObserver) this.videoObserver.disconnect();
  }

  render() {
    return (
      <div className="case">
        <div className="case-content" id="case-opus">
          <h1 className="opus-visually-hidden">Жилой комплекс «Опус»</h1>

          <section className="opus-cover">
            <div className="opus-cover__visual">
              <div className="opus-cover__background" aria-hidden="true" />
              <div className="opus-cover__building-mask">
                <div className="opus-cover__building-canvas">
                  <img src={`${base}/cover-building.png`} alt="Жилой комплекс Опус" loading="eager" />
                  <span aria-hidden="true" />
                </div>
              </div>
              <img className="opus-cover__logo" src={`${base}/cover-logo.svg`} alt="Опус" />
            </div>
            <div className="opus-cover__intro">
              <div>
                <h2>Жилой комплекс «Опус»</h2>
                <dl>
                  <div><dt>Клиент</dt><dd>Pioneer</dd></div>
                  <div><dt>Виды работ</dt><dd>Сайт</dd></div>
                </dl>
              </div>
              <div className="opus-cover__copy">
                {introCopy.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
              </div>
            </div>
          </section>

          <section className="opus-parallax opus-gap">
            <video ref={this.setVideoRef} muted loop playsInline preload="metadata" poster={`${base}/02.webp`}>
              <source src={`${base}/02-clean.mp4`} type="video/mp4" />
            </video>
          </section>

          {sections.map(section => section.showcase
            ? <VideoShowcase key={section.name} />
            : section.liveMobile
              ? <MobileSite key={section.name} setVideoRef={this.setVideoRef} />
              : <Frame key={section.name} setVideoRef={this.setVideoRef} {...section} />)}

          <section className="opus-mobile-showcase opus-gap" aria-label="Мобильные страницы сайта Опус">
            {[1, 2, 3, 4].map(index => (
              <img src={`${base}/mobile-0${index}.webp`} alt="" loading="lazy" key={index} />
            ))}
          </section>

          <CaseFooterNew
            to="/projects/dreamriva/"
            title="Dream Riva"
            img="/cases/img/dreamriva/dreamriva.webp"
            full={true}
          />
        </div>
        <HelmetSite title="Жилой комплекс «Опус»" />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Opus);
